import { render, staticRenderFns } from "./organization_contract_form.vue?vue&type=template&id=6bbc8754&scoped=true&"
import script from "./organization_contract_form.vue?vue&type=script&lang=js&"
export * from "./organization_contract_form.vue?vue&type=script&lang=js&"
import style0 from "./organization_contract_form.vue?vue&type=style&index=0&id=6bbc8754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc8754",
  null
  
)

export default component.exports